import { unit } from '../../../common/theme';
import { styled } from '../../../providers/context/StyletronProvider/withStyletronProvider';

export const FormContainer = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: unit[4],
}));
